import * as React from 'react';
import '../../sass/PageEditComponent.css';
import '../../sass/ToggleComponent.css';
import 'react-quill/dist/quill.snow.css'; // ES6
import '../../sass/quill-emoji.css';

import AppUtils from '../../utils/AppUtils';
import { PanelGroup, Button, FormGroup, FormControl, Panel, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Story from 'src/objects/Story';
import Tags from '../Tags';
import Tag from 'src/objects/Tag';
import {menu} from 'react-icons-kit/entypo/menu';
// import {lock} from 'react-icons-kit/entypo/lock';
import {SortableHandle} from 'react-sortable-hoc';
import { Icon } from 'react-icons-kit';
import {warning} from 'react-icons-kit/entypo/warning'
import Decision from 'src/objects/Decision';
import ReactHtmlParser from 'react-html-parser';
import DecisionComponent from './DecisionComponent';
import AppConfig from 'src/config/AppConfig';
import QuillComponent from './QuillComponent';

const DragHandle = SortableHandle(() => <span className="dragHandle"><Icon size={25} icon={menu}/></span>);

export default class PageEditComponent extends React.Component<any, any> {

    // private pageInput:string = "";

    private showWarningAlert:boolean = true;
    private decisions:Array<Decision> = this.props.decisions;
    private pageInput = this.props.pageText;
    private pageInputDecoded = this.props.pageTextDecoded;

    constructor(props: any) {
        super(props);
        //decisionList = this.props.decisions;
        //let decisionList = [];
        let randomStoryArray = [
            "Add your page text here. (Example: Uh oh! A bear has appeared...what do you do?)",
            "Add your page text here...(Example: Great...a zombie apocalypse. You have 10 seconds to choose a weapon. What do you go for?)",
            "Add your page text here...(Example: A decompression warning light in the spaceship cockpit starts flashing red. What do you do?)",
            "Add your page text here...(Did you know that you can also use HTML tags?)"
          ]
        let tags:Array<Tag> = this.props.story.tags;
        if (tags == null) {tags = []}
        this.state = {
            tags: tags,
            open: false,
            multiselect: false,
            timelimit: false,
            onceOnly: this.props.story.onceOnly,
            decisions: this.decisions,
            randomStory: randomStoryArray,
            randomStoryNum: Math.floor(Math.random()*randomStoryArray.length),
            pageInput: this.pageInput,
            pageInputDecoded: this.pageInputDecoded,
        };

        this.duplicateStory = this.duplicateStory.bind(this);
        this.savePage = this.savePage.bind(this);
        this.onAddDecision = this.onAddDecision.bind(this);
        this.expandPanel = this.expandPanel.bind(this);
        this.onPageInputChange = this.onPageInputChange.bind(this);
        this.handleOnToggle = this.handleOnToggle.bind(this);
        this.updatePageInput = this.updatePageInput.bind(this)
    }

    private onAddDecision(e:any) {
        let storys:Array<Story> = this.props.chapters[this.props.currentChapter].storys;
        let sIndex:number = AppUtils.getStoryIndex(this.props.chapters[this.props.currentChapter], this.props.id);
        let n:number = storys[sIndex].currentDecisionId + 1; // Decision goes up by 1 each time a new decision is added. This will ensure all keys and ids are unique.
        let decision:Decision = new Decision();
        decision.id = n;
        decision.outcome = "None";
        decision.impact = "Tiny";
        decision.shouldJump = false;
        decision.jumpPage = null;
        decision.jumpChapter = this.props.chapters[this.props.currentChapter].id;
        decision.decision = "";
        storys[sIndex].decisions.push(decision);
        storys[sIndex].currentDecisionId = n;
        this.props.onStoryUpdated(storys);
    }

    private updateTags(tags):void {
        this.setState({tags: tags});
    }

    // private handlePageChange(e:any) {
    //     let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
    //     let index:number = AppUtils.getStoryIndex(this.props.chapters[this.props.currentChapter], e.target.id);
    
    //     storys[index].text = e.target.value;
    //     this.props.onStoryUpdated(storys, !AppUtils.isMobile);
    //   }

    // private getValidationState() {
    //     const length = this.state.question.length;
    //     if (length > 0 && length < 140) return 'success';
    //     return 'error';
    // }

    private checkForError():boolean {
        let error:boolean = false;
        this.state.decisions.forEach(decision => {
            // console.log("D:", decision)
            if (decision.jumpChapter <= 0 || decision.jumpChapter == null || decision.decision == "" || decision.jumpPage == null) {
                error = true;
                console.log("Decision warning:", decision.jumpChapter, decision.decision, decision.jumpPage)
            }
        });
        return error;
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.open && this.props.shouldSave) {
            this.savePage();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // only update chart if the data has changed

        if (prevState.decisions !== this.props.decisions) {
            this.setState({decisions: this.props.decisions})
        }

        this.showWarningAlert = false;
    }

    private selectRandomStory() {
        return this.state.randomStory[this.state.randomStoryNum];
    }

    private onPressDeleteStory(e?:any) {
        console.log("deleting page")
        let chapters = this.props.chapters;
        let storys:Array<any> = chapters[this.props.currentChapter].storys;
        let i:number = AppUtils.getStoryIndex(this.props.chapters[this.props.currentChapter], this.props.id);
        chapters.forEach(chapter => {
            chapter.storys.forEach(story => {
                story.decisions.forEach(decision => {
                    // if (story.text == "test 1") {
                    //     console.log(story.text, "|", decision.jumpChapter, this.props.chapters[this.props.currentChapter].id, decision.jumpPage, this.props.id)
                    // }
                    if (decision.jumpChapter == this.props.chapters[this.props.currentChapter].id && decision.jumpPage == this.props.id) {
                        console.log("A decision was jumping to this story :(");
                        decision.jumpPage = null;
                    }
                });
            });
        });
        if (i != -1) {
            storys.splice(i, 1);
            this.props.onChapterUpdated(chapters);
        }
    }

    private canDelete():boolean {
        //console.log(this.props.chapters, this.props.currentChapter);
        if(this.props.chapters != null && this.props.currentChapter != null && this.props.story.locked != true) {
            let storysLength:number = this.props.chapters[this.props.currentChapter].storys.length;
            if (storysLength > 2 && this.props.canDelete) {
                return true;
            } else {
                return false;
            }
        }
    }

    // private truncateString(s:string, length:number, addElepsis:boolean = true):string {
    //     // if (s.length > length) {
    //     //     s = s.substring(0,length);
    //     //     if (addElepsis) {
    //     //         s += "...";
    //     //     }
    //     // }
    //     return s;
    // }

    private expandPanel() {
        if (this.state.open == false) {
            // this.savePage();
            this.setState({open: true});
        }
    }

    private closePage() {
        this.setState({open: false});
    }

    private getStyle() {
        if (this.canDelete()) {
            return "primary";
        }
        return "primary";
    }

    private getImpactColour(outcome:string, impact:string):string {
        return outcome + impact;
    }

    private isSelected() {
        if (this.props.storyPanelSelectedStoryID == this.props.id) {
            return 'panel-heading-selected';
        }
        return "";
    }

    private hasMissingDecisionProperty(jumpChapter:string, jumpPage:string, decisionText:string):boolean {
        let missing = false;
        // console.log("C: " + jumpChapter, "P: " + jumpPage)
        if (jumpChapter == null || jumpPage == null || decisionText == "") {
            missing = true;

            if (this.showWarningAlert = false) {
                this.showWarningAlert = true;
            }
        }
        return missing;
    }

    public savePage(e:any = null):any {
        // console.log("SAVE")
        if (e != null) { e.preventDefault(); }
        
        let storys:Array<any> = this.props.chapters[this.props.currentChapter].storys;
        let index:number = AppUtils.getStoryIndex(this.props.chapters[this.props.currentChapter], this.props.id);
        let story:Story = storys[index];

        story.text = this.state.pageInput;
        story.textDecoded = this.state.pageInputDecoded;
        if (story.textDecoded == null) {
            story.textDecoded = story.text;
        }
        story.decisions = this.state.decisions;
        if (story.multiselect != null) {
            story.multiselect = this.state.multiselect
        } else {
            story["multiselect"] = this.state.multiselect
        }
        let onceOnly:boolean = this.state.onceOnly
        if (onceOnly == null) {onceOnly = false}
        if (story.onceOnly != null) {
            story.onceOnly = onceOnly
        } else {
            story["onceOnly"] = onceOnly
        }
        if (story.tags != null) {
            story.tags = this.state.tags
        } else {
            story["tags"] = this.state.tags
        }

        this.props.onStoryUpdated(storys, true, false);
        // console.log("Adding new page: ", this.state.addPageInput)
        this.closePage();
    }

    private duplicateStory(e:any = null):any {
        this.props.addNewPage(this.state.pageInput, this.state.decisions, this.props.index + 1);
    }

    private onDecisionsUpdated(decisions:any) {
        this.setState({decisions: decisions});
    }

    private onPageInputChange(event) {
        this.updatePageInput(event.target.value)
    }

    private updatePageInput(value, delta?, source?, editor?) {
        this.setState({ pageInput: value, pageInputDecoded: editor.getText()})
    }

    private handleOnToggle() {
        // console.log("Toggled", this.props)
        // this.props.closeCurrentOpenPage(this);
    }

    private toggleOnceOnly() {
        this.setState({onceOnly: !this.state.onceOnly})
    }

    private toggleTimelimit() {
        this.setState({timelimit: !this.state.timelimit})
    }

    private toggleMultiselect() {
        this.setState({multiselect: !this.state.multiselect})
    }

    render() {
        return (
            <li className={this.props.story.locked? 'page lockedStory' : 'page'} suppressContentEditableWarning={true}>
                {this.props.story.locked? null : <DragHandle />}
                <Panel eventKey={this.props.id} bsStyle={this.getStyle()} expanded={this.state.open} onToggle={this.handleOnToggle}>
                    <Panel.Heading className={this.isSelected()} hidden={this.props.headerHidden}>
                        <div className="pageButtons">
                            <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"pageTooltip1"+this.props.id.toString()} placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                {this.state.open? "Save" : "Edit"}
                                </Tooltip>
                            }>
                                <Button className="editPageBtn highlightOnHover" bsStyle="default" onClick={this.state.open? this.savePage : this.expandPanel}>
                                    <Glyphicon glyph={this.state.open? "ok" : "pencil"} />
                                </Button>
                            </OverlayTrigger>
                            { !this.props.story.locked ?
                            <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"pageTooltip3"+this.props.id.toString()} placement="top"
                            overlay={
                                <Tooltip id={`tooltip-top`}>
                                Duplicate
                                </Tooltip>
                            }>
                                <Button className="editPageBtn highlightOnHover" bsStyle="default" onClick={this.duplicateStory}>
                                    <Glyphicon glyph={"duplicate"} />
                                </Button>
                            </OverlayTrigger> : null
                            }
                            {
                                this.canDelete() ?
                                <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"pageTooltip2"+this.props.id.toString()} placement="top"
                                    overlay={
                                        <Tooltip id={`tooltip-top`}>Delete</Tooltip>
                                    }>
                                    <Button className="editPageBtn highlightOnHover" id={this.props.id.toString()} bsStyle="default" onClick={() => this.onPressDeleteStory()}>
                                        <Glyphicon glyph="trash" />
                                    </Button>
                                </OverlayTrigger>
                                : null
                            }
                        </div>
                        { 
                            !this.state.open ?
                            <div suppressContentEditableWarning={true}>
                                <Panel.Title onClick={this.expandPanel} toggle className="storyPanelTitle">{ReactHtmlParser(this.props.pageText)}</Panel.Title>
                                {
                                    !this.props.story.locked ?
                                    <div className="decisionsContainer">
                                        {this.checkForError() ? <Icon className="decisionsErrorIcon" size={22} icon={warning}/>:null }
                                        {this.state.decisions.map((c:any, i:number) => 
                                            <p onClick={this.expandPanel} key={"decision"+i} className={this.hasMissingDecisionProperty(c.jumpChapter, c.jumpPage, c.decision) ? "decision decisionError" : "decision " + this.getImpactColour(c.outcome, c.impact)}>{c.decision == "" ? "NA" : c.decision}</p>
                                        )}
                                    </div> : null
                                }
                                
                            </div>
                            :
                            <QuillComponent id={this.props.id} pageInput={this.state.pageInput} updatePageInput={this.updatePageInput}/>
                        }
                    </Panel.Heading>
                    {
                        !this.props.story.locked ?
                        <Panel.Collapse>
                            <Panel.Body>
                                <form onSubmit={this.savePage} suppressContentEditableWarning={true}>
                                    <PanelGroup
                                        accordion
                                        id="accordion-controlled-example"
                                        className='decisionPanelGroup'>
                                        {this.state.decisions.map((c:any, i:number) => 
                                        <DecisionComponent
                                            id={c.id}
                                            key={c.id}
                                            linkUrl={c.linkUrl}
                                            text={c.decision}
                                            shouldJump={c.shouldJump}
                                            jumpChapter={c.jumpChapter}
                                            chapters={this.props.chapters}
                                            currentChapter={this.props.currentChapter}
                                            jumpPage={c.jumpPage}
                                            outcome={c.outcome}
                                            impact={c.impact}
                                            move={c.move}
                                            numberOfDecisions={this.state.decisions.length}
                                            decisions={this.state.decisions}
                                            onDecisionsUpdated={this.onDecisionsUpdated.bind(this)}
                                            storyId={this.props.id}
                                            // savePage={this.savePage.bind(this)}
                                        />)}
                                    </PanelGroup>
                                    <Button className="addDecisionBtn" bsStyle="default" onClick={this.onAddDecision}>
                                        Add Decision
                                    </Button>
                                    <div id="pageSettings">
                                        <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} key={"pageTooltip2"+this.props.id.toString()} placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-top`}>Learners can only select each decision once</Tooltip>
                                            }>
                                            <Button className={this.state.onceOnly? "settingButtonSelected" : "settingButton"} bsStyle="default" onClick={this.toggleOnceOnly.bind(this)}>
                                                Once Only
                                            </Button>
                                        </OverlayTrigger>
                                        <div id="pageTags">
                                            <Tags recommendedTags={this.props.recommendedTags} tags={this.state.tags} updateTags={this.updateTags.bind(this)}/>
                                        </div>
                                        {/* <Button className={this.state.multiselect? "settingButtonSelected" : "settingButton"} bsStyle="default" onClick={this.toggleMultiselect.bind(this)}>
                                            Multi-select
                                        </Button> */}
                                    </div>
                                </form> 
                            </Panel.Body>
                        </Panel.Collapse> : null
                    }
                </Panel>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/PageEditComponent.tsx